import { isAcronym, formatTitleCase } from "@/helpers/utils";

export { getSkuColor, cleanSkuName } from "./constants";

const CAPITALIZED_PRODUCT_NAMES = ["DLT", "SQL"];

/**
 * Formats a product name from snake_case to Title Case, preserving acronyms.
 *
 * @example
 * formatProductName("jobs") => "Jobs"
 * formatProductName("all_purpose") => "All Purpose"
 * formatProductName("model_serving") => "Model Serving"
 * formatProductName("sql") => "SQL"
 * formatProductName("dlt") => "DLT"
 * formatProductName("dlt_pipeline") => "DLT Pipeline"
 */
export const formatProductName = (product: string): string => {
  return product
    .split("_")
    .map(word => {
      if (isAcronym(word) || CAPITALIZED_PRODUCT_NAMES.includes(word.toUpperCase())) {
        return word.toUpperCase();
      }
      return formatTitleCase(word);
    })
    .join(" ");
};
